import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import "../assets/style.scss"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const Descriptions = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)
    return (
        <Block type="section" className="container notes-page-wrapper" id="landing-page-wrapper">
            <Block className="container container-campaign container-campaign-images">
                <Block className="box notes-box-container">
                    <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "PosBasvuru.Landing.Notes") }} />
                </Block>
            </Block>
        </Block>
    )
}

export default Descriptions
